import { useHistory } from 'react-router-dom';

import useFetchWrapper, { HttpResponse } from '../../Helpers/useFetchWrapper';

import { ForgotPasswordData } from './ForgotPassword.model';

const useLogin = () => {
	const { post } = useFetchWrapper();
	const history = useHistory();

	const navigateTo = (path: string) => {
		history.push(path);
	}

	const onSubmit = async (data: ForgotPasswordData) => {
		const res: HttpResponse<any> = await post('/user/reset-password/request', data, true);
		
		if (res.ok) {
			navigateTo('/');
		}
	}

	return {
		navigateTo,
		onSubmit,
	}
}

export default useLogin;